module.exports = __webpack_public_path__ + "img/fabric_logo-sm.3c9dbf09.6c6afe03.png";